/// <amd-module name="TFS/Views/ProjectOverviewPage/ProjectOverviewTab/Components/ServiceLink" />
import * as React from "react";
import { ITfsPageService } from "Tfs/Platform/Page";
import { OverviewTabTelemetryConstants } from "TFS/Views/ProjectOverviewPage/ProjectOverviewTab/Constants";
import * as Resources from "TFS/Views/ProjectOverviewPage/Resources";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { onClickFPS } from "VSS/Platform/FPS";
import { IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { routeUrl } from "VSS/Platform/Location";
import { Button } from "VSSUI/Button";
import { css } from "VSSUI/Util";

interface IVssProductFeatureContribution {
    name: string;
    defaultRoute: string;
}

interface ServiceLinkComponentProps extends IVssComponentProperties {
    serviceNavigationInfoId: string;
}

interface ServiceLinkComponentState {
    url: string | undefined;
    name: string | undefined;
}

class ServiceLinkComponent extends VssComponent<ServiceLinkComponentProps, ServiceLinkComponentState> {
    constructor(props: ServiceLinkComponentProps, context: IVssComponentContext) {
        super(props, context);

        const contributionService = context.pageContext.getService<IVssContributionService>("IVssContributionService");
        const serviceNavigationInfo = contributionService.getContribution<IVssProductFeatureContribution>(props.serviceNavigationInfoId);

        let serviceUrl: string | undefined = undefined;
        let serviceName: string | undefined = undefined;
        if (serviceNavigationInfo) {
            const routeId = serviceNavigationInfo.defaultRoute;
            const tfsPageData = context.pageContext.getService<ITfsPageService>("ITfsPageService").getData();

            let projectName: string | undefined = undefined;

            if (tfsPageData && tfsPageData.project) {
                projectName = tfsPageData.project.name;
            }

            serviceUrl =
                projectName && routeId
                    ? routeUrl(context.pageContext, routeId, {
                          project: projectName ? projectName : ""
                      })
                    : undefined;
            serviceName = serviceNavigationInfo.name;
        }

        this.state = {
            url: serviceUrl,
            name: serviceName
        };
    }

    public render(): JSX.Element | null {
        const { name, url } = this.state;
        return url && name ? (
            <Button className={css("service-link", this.props.className)} href={url} onClick={this._onClick} ariaRoleDescription={Resources.Link}>
                {name}
            </Button>
        ) : null;
    }

    private _onClick = (event?: any) => {
        if (this.state.url) {
            onClickFPS(this.context.pageContext, this.state.url, true, event, {
                telemetrySource: OverviewTabTelemetryConstants.DayZero_ServiceNavigationLink
            });
        }
    };
}

VssComponent.register("TFS.ServiceNavigationLink", ServiceLinkComponent);
